module.exports = "<app-cambio-dolar-venta [cotizacion]=\"cotizacion\"></app-cambio-dolar-venta>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/cotizacion/cotizacion-edit/cotizacion-edit.component.html
// module id = ./src/app/shared-components/cotizacion/cotizacion-edit/cotizacion-edit.component.html
// module chunks = main